import { Modal, Input, Checkbox, Empty } from "antd";
import SortingArrow from "../../Common/SortingArrow";
import { useEffect, useState } from "react";

const SelectAssociateDropZone = ({
  isOpen,
  onCancel,
  onOk,
  allDropZones,
  selectedItems,
}) => {
  const { Search } = Input;

  const [items, setItems] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [seletedIdes, setSeletedIdes] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleCheckboxChange = (id) => {
    setSeletedIdes((prevIds) =>
      prevIds.includes(id)
        ? prevIds.filter((itemId) => itemId !== id)
        : [...prevIds, id]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      // Uncheck all items
      setSeletedIdes([]);
    } else {
      // Check all items and add their ids
      const allIds = items.map((item) => item.id);
      setSeletedIdes(allIds);
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    let insertedData = [];
    if (allDropZones?.length > 0) {
      for (let itm of allDropZones) {
        let push = true;
        if (selectedItems?.length) {
          for (let row of selectedItems) {
            if (row.dropZoneId === itm.id) push = false;
          }
        }
        if (push) {
          let dropZoneLocalesName = "";
          if (itm?.dropZoneLocales)
            for (let row of itm?.dropZoneLocales) {
              if (row.languageCode === "en") dropZoneLocalesName = row.name;
            }
          insertedData.push({
            id: itm.id,
            name: dropZoneLocalesName,
            address: itm?.address,
            discount: itm?.discount,
            volume: itm?.volume,
          });
        }
      }
      setItems(insertedData);
    }

    setSeletedIdes([]);
  }, [allDropZones, selectedItems]);

  const searchDropZones = async (value) => {
    const filteredData = allDropZones
      .filter(
        (itm) =>
          itm?.zoneDetails[0]?.name
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          itm?.address.toLowerCase().includes(value.toLowerCase())
      )
      .map((itm) => ({
        id: itm.id,
        name: itm?.zoneDetails[0]?.name,
        address: itm?.address,
        discount: itm?.discount,
        volume: itm?.volume,
      }));

    setItems(filteredData);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedItems = [...items].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setItems(sortedItems);
  };

  return (
    <>
      <Modal
        title="Associate Dropzone"
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={() => {
          onOk(seletedIdes);
        }}
        width={1000}
        okText="Save"
        okButtonProps={{ disabled: seletedIdes.length === 0 }}
      >
        <div className="mb-4 flex justify-end">
          <Search
            placeholder="Search by name"
            style={{
              width: 200,
            }}
            className="mx-1.5 cursor-pointer"
            onChange={(e) => {
              searchDropZones(e.target.value);
            }}
          />
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  <Checkbox checked={selectAll} onChange={handleSelectAll}>
                    All
                  </Checkbox>
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Name (English){" "}
                  <SortingArrow onSort={() => handleSort("name")} />
                </th>
                <th scope="col" className="px-3 py-3">
                  Address <SortingArrow onSort={() => handleSort("address")} />
                </th>
              </tr>
            </thead>
            <tbody>
              {items?.length ? (
                items?.map((item, index) => (
                  <>
                    <tr key={item.id} className="bg-white border-b">
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        <Checkbox
                          checked={seletedIdes.includes(item.id)}
                          onChange={() => handleCheckboxChange(item.id)}
                        />
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item.name}
                      </td>
                      <td className="px-3 py-4 vertical-top">{item.address}</td>
                    </tr>
                  </>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center mt-4">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal>
    </>
  );
};
export default SelectAssociateDropZone;
